var _circle, _g, _path, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTickSuccess = function SvgTickSuccess(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.5,
    r: 40.5,
    fill: "#3A2F81",
    fillOpacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1445_16343)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.5,
    r: 17.5,
    fill: "#3A2F81"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2725 38.7978C35.1491 38.6729 35.0025 38.5739 34.8411 38.5063C34.6796 38.4387 34.5065 38.4039 34.3317 38.4039C34.1569 38.4039 33.9838 38.4387 33.8223 38.5063C33.6609 38.5739 33.5143 38.6729 33.3909 38.7978C33.267 38.922 33.1687 39.0697 33.1016 39.2324C33.0345 39.3951 33 39.5695 33 39.7456C33 39.9217 33.0345 40.0961 33.1016 40.2588C33.1687 40.4214 33.267 40.5691 33.3909 40.6934L38.1742 45.5126L38.2519 45.5908C38.3685 45.7085 38.5071 45.802 38.6597 45.8657C38.8122 45.9295 38.9757 45.9623 39.1409 45.9623C39.306 45.9623 39.4696 45.9295 39.6221 45.8657C39.7747 45.802 39.9132 45.7085 40.0299 45.5908L48.2916 37.2671C48.4085 37.1496 48.5013 37.01 48.5645 36.8563C48.6278 36.7026 48.6604 36.5378 48.6604 36.3714C48.6604 36.2051 48.6278 36.0403 48.5645 35.8866C48.5013 35.7329 48.4085 35.5933 48.2916 35.4758L48.1881 35.3715C48.0715 35.2537 47.9329 35.1603 47.7804 35.0966C47.6278 35.0328 47.4643 35 47.2991 35C47.134 35 46.9705 35.0328 46.8179 35.0966C46.6654 35.1603 46.5268 35.2537 46.4101 35.3715L39.139 42.6933L35.2725 38.7978Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1445_16343",
    x: 11,
    y: 11,
    width: 59,
    height: 59,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.152941 0 0 0 0 0.12549 0 0 0 0 0.329412 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1445_16343"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1445_16343",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTickSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tick-success.c8068887.svg";
export { ForwardRef as ReactComponent };